import React from "react";
import { Card, Tag, Typography, Space, Button, Tooltip, theme } from "antd";
import {
  ClockCircleOutlined,
  EditOutlined,
  DeleteOutlined,
  StarFilled,
} from "@ant-design/icons";
import { ScheduleTemplate } from "../../../../../types/scheduleTemplate";
const { Text, Title } = Typography;

interface ScheduleTemplateCardProps {
  template: ScheduleTemplate;
  onEdit: (template: ScheduleTemplate) => void;
  onDelete: (id: string) => void;
  onSetDefault: (id: string) => void;
}

const ScheduleTemplateCard: React.FC<ScheduleTemplateCardProps> = ({
  template,
  onEdit,
  onDelete,
}) => {
  const { token } = theme.useToken();

  const formatTime = (hour: number, min: number) => {
    const period = hour >= 12 ? "PM" : "AM";
    const displayHour = hour === 0 ? 12 : hour > 12 ? hour - 12 : hour;
    return `${displayHour}:${min.toString().padStart(2, "0")} ${period}`;
  };

  const startTime = formatTime(template.startWorkHour, template.startWorkMin);
  const endTime = formatTime(template.endWorkHour, template.endWorkMin);

  return (
    <Card
      hoverable
      style={{ height: "100%" }}
      actions={[
        <Tooltip title="Edit Template">
          <Button
            type="text"
            icon={<EditOutlined />}
            onClick={() => onEdit(template)}
          />
        </Tooltip>,
        <Tooltip title="Delete Template">
          <Button
            type="text"
            icon={<DeleteOutlined />}
            onClick={() => onDelete(template.id)}
            disabled={template.isDefault}
            danger
          />
        </Tooltip>,
      ]}
    >
      <Space direction="vertical" style={{ width: "100%" }} size="middle">
        <div>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              marginBottom: 8,
            }}
          >
            <Title level={5} style={{ margin: 0 }}>
              {template.name}
            </Title>
            {template.isDefault && (
              <Tag color="gold" icon={<StarFilled />}>
                Default
              </Tag>
            )}
          </div>
          <Text type="secondary">{template.description}</Text>
        </div>

        <div
          style={{
            padding: 16,
            backgroundColor: token.colorFillTertiary,
            borderRadius: 6,
            textAlign: "center",
          }}
        >
          <Space direction="vertical" size="small">
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: 8,
              }}
            >
              <ClockCircleOutlined style={{ color: token.colorPrimary }} />
              <Text strong>Work Hours</Text>
            </div>
            <div
              style={{
                fontSize: 18,
                fontWeight: 600,
                color: token.colorPrimary,
              }}
            >
              {startTime} - {endTime}
            </div>
          </Space>
        </div>

        <div style={{ fontSize: 12, color: token.colorTextSecondary }}>
          Created: {new Date(template.createdAt).toLocaleDateString()}
        </div>
      </Space>
    </Card>
  );
};

export default ScheduleTemplateCard;
